const ws_base = {
  // ----------- File 1 Ws配置 ----------- 
  // wsHost : "10.10.4.6", // 测试环境 10.10.4.6
  // wsPort : "16666",         // 暂时固定
  wsPath: "/msgws", // 固定
  // ----------- File 2 全局ws业务定义，和服务端同步定义 ----------- 
  AGENT_WEB_MSG: 1012, // 投影仪即时显示的文字消息业务
}

export {
  ws_base
}


// WEBPACK FOOTER //
// ./src/http/ws_base.js